export type SparkTone = '' | 'accent' | 'warning' | 'danger' | 'success';

export interface SparkProps {
  values: number[];
  tone?: SparkTone;
  height?: number;
}

export function Spark({ values, tone = '', height = 28 }: SparkProps) {
  if (!values || values.length === 0) {
    return <div className="ds-spark-bars" style={{ height }} />;
  }
  const max = Math.max(...values, 1);
  const toneCls = tone ? ` ds-spark-${tone}` : '';
  return (
    <div className={`ds-spark-bars${toneCls}`} style={{ height }}>
      {values.map((v, i) => (
        <i key={i} style={{ height: `${Math.max(2, (v / max) * height)}px` }} />
      ))}
    </div>
  );
}

export default Spark;
